<template>
  <div id="app">
    <div v-if="$keycloak.ready" class="row">
      <TheSidebar class="mt-0" />
    </div>
    <router-view :key="$route.fullPath"></router-view>
    <label class="text-white"> © {{ currentYear }} Σώμα Ελλήνων Προσκόπων Πτολεμαίων 1, 11635, Αθήνα | Τηλ: 2107290046 |
      Φάξ: 2107236561 | hello@sep.org.gr</label>

  </div>
</template>

<script>
import TheSidebar from 'esep/src/components/TheSidebar.vue';
import trainingService from './services/training.service';

const now = new Date();
const currentYear = now.getFullYear();
export default {
  name: 'App',
  components: {
    TheSidebar
  },
  data() {
    return {
      currentYear: currentYear
    }
  },
  mounted() {
    trainingService.getUserInfo(null).then(
      (resp) => {
        this.$store.state.userInfo = resp.data;
        trainingService.getAccessibleUnits(resp.data.orgMember.id).then(
          (response) => {
            this.$store.state.usersAccessibleUnits = response.data;
          }
        );
      }
    )
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>

<style lang="scss">
@import '@/assets/scss/app.scss';
</style>